import { createSlice } from "@reduxjs/toolkit";

// Initial state for the slice
const initialState = {
  id: null,
  roles: null,
  pagePermission: {},
};

const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.id = action.payload.id;
      state.roles = action.payload.role;
      state.pagePermission = action.payload.pagePermission;
    },
  },
});

// Exporting the actions and reducer
export const { setPermissions } = userPermissionsSlice.actions;
export default userPermissionsSlice.reducer;
